import { useReduxState } from 'hooks';
import { Alert } from 'components/common';

interface Props {
  text: string;
}

const ReaderSidebarOfflineWarning = ({ text }: Props) => {
  const {
    pageState: { readerTheme }
  } = useReduxState();

  return (
    <Alert
      icon="exclamation-triangle"
      size="small"
      style={{
        backgroundColor: readerTheme?.sidebarInnerBackgroundColor,
        color: readerTheme?.sidebarInnerColor,
        marginBottom: 10
      }}
      text={text}
    />
  );
};

export default ReaderSidebarOfflineWarning;
